// Frontend i18n bootstrap — react-i18next.
//
// Phase 1 supports English (default) and Spanish (neutral LatAm).
// Adding a new language is a 2-step process:
//   1) Drop a `locales/<code>.json` file with the same key tree as `en.json`.
//   2) Add the code to `SUPPORTED_LOCALES` below.
//
// User preference resolution order (set via i18n.changeLanguage):
//   1) currentUser.preferred_locale from /api/auth/me
//   2) localStorage  (browser-language-detector key 'sl_locale')
//   3) Default → 'en'
//
// Stored strings (customer names, part names, job notes, PO descriptions,
// addresses, audit logs) are NEVER translated by i18n.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

export const SUPPORTED_LOCALE_CODES = SUPPORTED_LOCALES.map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALE_CODES,
    nonExplicitSupportedLngs: true,   // 'es-MX' → 'es'
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'sl_locale',
      caches: ['localStorage'],
    },
    returnEmptyString: false,
  });

export default i18n;
